import FavoriteIcon from "@mui/icons-material/Favorite";
import Carousel from "react-multi-carousel";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  IconButton,
  Typography,
  ButtonBase,
  Stack,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SchoolIcon from "@mui/icons-material/School";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const HomeCarousel = (props) => {
  const navigate = useNavigate();
  return (
    <Carousel
      responsive={props.responsive}
      autoPlay={false}
      infinite={true}
      swipeable
      draggable
      removeArrowOnDeviceType={["mobile"]}
    >
      {props.content?.data?.length ? (
        props.content.data.slice(0, 10).map((d, i) => (
          <Box key={i} sx={{ padding: "10px 15px 10px 0px" }}>
            <ButtonBase
              className="profile-btn"
              onClick={() => navigate(`/auth/home/view-profile/${d.id}`)}
              sx={{ display: "block", textAlign: "left", width: "100%" }}
            >
              <Card
                className="profile-card"
                elevation={1}
                sx={{
                  maxWidth: 320,
                  height: 320,
                  display: "flex",
                  flexDirection: "column",
                  borderRadius: 2,
                  overflow: "hidden",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                  },
                }}
              >
                <Box
                  sx={{ position: "relative", height: "65%", flexShrink: 0 }}
                >
                  {d.image ? (
                    <CardMedia
                      component="img"
                      image={d.image}
                      alt={d.name}
                      onError={(event) => {
                        event.currentTarget.style.display = "none";
                        const fallback = event.currentTarget.nextElementSibling;
                        if (fallback) fallback.style.display = "flex";
                      }}
                      sx={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : null}

                  <Box
                    sx={{
                      position: "absolute",
                      inset: 0,
                      display: d.image ? "none" : "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      background:
                        "linear-gradient(135deg, rgba(48,48,48,0.75), rgba(95,95,95,0.7))",
                      backdropFilter: "blur(6px)",
                      WebkitBackdropFilter: "blur(6px)",
                      px: 2,
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#fff",
                        fontWeight: 600,
                        letterSpacing: 0.4,
                        textTransform: "uppercase",
                      }}
                    >
                      No Image Available
                    </Typography>
                  </Box>

                  <IconButton
                    aria-label="shortlist"
                    size="small"
                    onMouseDown={(event) => event.stopPropagation()}
                    onClick={(event) => {
                      event.stopPropagation();
                      event.preventDefault();
                      props.onClickLike && props.onClickLike(d);
                      console.log("props.onClickLike", d);
                      console.log("props.shortListProfile", props);
                      props.shortListProfile &&
                        props.shortListProfile(d.id, !d.is_liked);
                    }}
                    sx={{
                      position: "absolute",
                      top: 8,
                      right: 8,
                      backgroundColor: "rgba(255, 255, 255, 0.85)",
                      backdropFilter: "blur(4px)",
                      "&:hover": {
                        backgroundColor: "rgba(255, 255, 255, 1)",
                      },
                      position: "absolute",
                    }}
                  >
                    <FavoriteIcon
                      fontSize="small"
                      sx={{
                        color: d.is_liked ? "#d53833" : "rgba(0, 0, 0, 0.54)",
                      }}
                    />
                  </IconButton>
                </Box>

                <CardContent
                  sx={{
                    flex: 1,
                    padding: 1.5,
                    "&:last-child": { paddingBottom: 1.5 },
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    fontWeight={600}
                    noWrap
                    gutterBottom
                  >
                    {d.name}
                  </Typography>

                  <Stack spacing={0.5}>
                    <Typography variant="caption" color="text.secondary">
                      Age: {d.age != null ? `${d.age} yrs` : "-"}
                    </Typography>

                    {/* <Stack direction="row" spacing={0.5} alignItems="center">
                      <SchoolIcon sx={{ height: 14, width: 14, color: "text.secondary" }} />
                      <Typography variant="caption" color="text.secondary" noWrap>
                        {d.education != null ? d.education : "-"}
                      </Typography>
                    </Stack> */}

                    <Stack direction="row" spacing={0.5} alignItems="center">
                      <LocationOnIcon
                        sx={{ height: 14, width: 14, color: "text.secondary" }}
                      />
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        noWrap
                      >
                        {d.city != null ? d.city : "-"}
                      </Typography>
                    </Stack>
                  </Stack>
                </CardContent>
              </Card>
            </ButtonBase>
          </Box>
        ))
      ) : (
        <Typography variant="h6" component="p" className="profile-no-record">
          No matching profiles found.
        </Typography>
      )}
    </Carousel>
  );
};

export default HomeCarousel;
